import React from 'react';
import { fixPathFor } from '../data/fixPaths';
import './FixPath.css';

const OPEN = <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M14 4h6v6M20 4l-9 9M18 14v5H5V6h5" /></svg>;
const WRENCH = <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M14.7 6.3a4 4 0 0 0-5.4 5.4L3 18l3 3 6.3-6.3a4 4 0 0 0 5.4-5.4l-2.5 2.5-2.4-.6-.6-2.4z" /></svg>;

// "Sådan retter du det": where the finding is fixed in Microsoft's portals (portal and menu path). The portal's name in the path is
// the link to the portal's front page (it opens in a new tab). Shows nothing for a finding without a known path. NordComply changes
// nothing itself. (Putting the finding on the IT list is done from the finding window, not here.)
export default function FixPath({ findingKey }) {
  const fix = fixPathFor(findingKey);
  if (!fix) return null;
  return (
    <div className="fixp">
      <div className="fixp__h">{WRENCH}<h6>Sådan retter du det</h6></div>
      <div className="fixp__p">
        <a className="fixp__lnk" href={fix.url} target="_blank" rel="noopener noreferrer" title={`Åbn ${fix.portal} i Microsoft. NordComply ændrer intet selv.`}>{fix.portal}{OPEN}</a>
        {fix.path.map((step) => <React.Fragment key={step}><i aria-hidden="true">›</i><span>{step}</span></React.Fragment>)}
      </div>
    </div>
  );
}
